import {
  Box,
  Flex,
  Text, LegacyText,
  PrimaryButton,
  RadioGroup,
  Radio,
  Stack,
} from "flicket-ui";
import { Select } from "~components";
import { useIsMobile } from "~hooks";
import {
  AlcoholFreeZoneTypes,
  CoverTypes,
  SortTypes,
} from "~components/reservation/constants";

type OptionsProps = {
  handleClose: () => void;
  setAmount: (amount: number) => void;
  amount: number;
  seatAmountOptions: any;
};

// eslint-disable-next-line react/prop-types
export const CoverType = ({ selectedType, changeCoverType }) => (
  <Stack flexDir="column" space={5} width="100%" mb={3}>
    <RadioGroup
      toggle
      value={selectedType}
      onChange={changeCoverType}
      space={5}
    >
      <Radio value={CoverTypes.ALL}>
        <LegacyText>No preference</LegacyText>
      </Radio>
      <Radio value={CoverTypes.COVERED}>
        <LegacyText>Covered</LegacyText>
      </Radio>
      <Radio value={CoverTypes.UNCOVERED}>
        <LegacyText>Uncovered</LegacyText>
      </Radio>
    </RadioGroup>
  </Stack>
);

// eslint-disable-next-line react/prop-types
export const AlcoholFreeZone = ({ alcoholFreeZone, changeAlcoholFreeZone }) => (
  <Stack flexDir="column" space={5} width="100%" mb={2}>
    <RadioGroup
      toggle
      value={alcoholFreeZone}
      onChange={changeAlcoholFreeZone}
      space={5}
    >
      <Radio value={AlcoholFreeZoneTypes.NO_PREFERENCE}>
        <LegacyText whiteSpace="nowrap">No preference</LegacyText>
      </Radio>
      <Radio value={AlcoholFreeZoneTypes.YES}>
        <LegacyText>Yes</LegacyText>
      </Radio>
      <Radio value={AlcoholFreeZoneTypes.NO}>
        <LegacyText>No</LegacyText>
      </Radio>
    </RadioGroup>
  </Stack>
);

// eslint-disable-next-line react/prop-types
export const SortBy = ({ selectedSort, changeSort }) => (
  <Stack flexDir="column" space={5} width="100%" mb={2}>
    <RadioGroup toggle value={selectedSort} onChange={changeSort} space={5}>
      <Radio value={SortTypes.BEST_AVAILABLE}>
        <LegacyText>Best available</LegacyText>
      </Radio>
      <Radio value={SortTypes.PRICE}>
        <LegacyText>Price</LegacyText>
      </Radio>
    </RadioGroup>
  </Stack>
);

export const Options = ({
  handleClose,
  setAmount,
  amount,
  seatAmountOptions,
}: OptionsProps) => {
  const isMobile = useIsMobile();
  return (
    <Flex flexDir="column" width="100%" p={{ _: 2, md: 0 }}>
      <Box>
        <LegacyText fontWeight="extraBold" color="N800" fontSize={2} mb="6/4">
          I need tickets for
        </LegacyText>
        <Select
          value={seatAmountOptions.find((opt) => opt.value === amount)}
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          onChange={({ value }) => setAmount(value)}
          options={seatAmountOptions}
          mb={5}
          selectProps={{
            // 300 is the default max menu height
            // This fixes a bug on android Chrome
            // where the dropdown does off the bottom viewport
            maxMenuHeight: isMobile ? 150 : 300,
          }}
        />
      </Box>

      <PrimaryButton mt={3} mb={5} onClick={handleClose}>
        Seat Select
      </PrimaryButton>
    </Flex>
  );
};
